import { Box, Button, Typography, styled } from "@mui/material";

export const FormContribution = styled(Box)`
  /* border: 1px solid #4dfd47; */
  border-radius: 8px;
  /* background: linear-gradient(
    90deg,
    rgba(121, 121, 121, 0.1),
    rgba(255, 255, 255, 0.1)
  ); */
  padding: 12px;
  font-size: 18px;
  font-weight: 500;

  form {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .input-contribute {
    height: 48px;
    width: 100%;
    input {
      color: white;
    }
    background-color: #98989836;
    border: 1px solid #787878;
    padding: 4px 12px;
    border-radius: 8px;
  }

  .select-contribute {
    /* box-shadow: 2px 2px 0px #aeaeae; */
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.07px;
    text-transform: uppercase;
    border-radius: 8px;
    height: 48px;

    display: flex;
    align-items: center;
    gap: 12px;

    .MuiSelect-select {
      font-size: 14px;
      border: 1px solid #787878;
      background-color: #98989836;
    }

    .MuiInputBase-input {
      padding: 0 8px !important;
      /* background-color: #cecece; */
      width: 50px;
      height: 48px;
      display: flex;
      align-items: center;
      color: #fff;
      border-radius: 8px;

      .MuiSelect-select {
        padding: 0;
      }
      &:focus-visible {
        outline: none;
      }
    }
    svg {
      color: #fff;
      width: 20px;
      height: 20px;
      margin-top: 2px;
    }
    fieldset {
      border-color: transparent !important;
    }

    .button-submit {
      background-color: #98989836;
      padding: 0 24px;
      height: 100%;
      font-size: 18px;
      border-radius: 8px;
      border: 1px solid #fdfc46;
      color: #fdfc46;
    }
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .your-balance {
    font-size: 12px;
    color: #b1b1b1;
    margin-bottom: 6px;
  }
`;
export const LogoSocial = styled("img")(() => ({
  width: "24px",
  marginRight: "20px",
}));

export const ConnectButtonBox = styled(Button)(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "left !important",
  background: "#fff",
  boxShadow: " 1px 1px 0px 0px #0D1615",
  borderRadius: "10px",
  border: "1px solid #0D1615",
  padding: "10px",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "15px",
  letterSpacing: "0.07px",
  alignItems: "center",
  textTransform: "none",
}));

export const TextConnect = styled(Typography)`
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
`;
